import ajaxRequest from 'utils/_ajax-request.js'
import orderFiles from '4-order-detail-cards/attachments/_index.js'
import textareaCounter from '4-component/textarea-counter/_index.js'
import chat from '4-order-detail-cards/chat/_index.js'
import additionalDescription from '4-order-detail-cards/properties/_index.js'
import {openDownloadLink, downloadSelected, deleteSelected} from 'utils/_download.js'
import {loadingWindowVisible, loadingWindowHidden, loadingWindowHandler} from '4-component/loading/_index.js'
import { convertDateManual, convertDateAuto, convertDateObject, convertDateCE, convertDateBeforeSend } from 'utils/_convert_date.js'
//import ajaxOpenButton from 'utils/_ajax-open-button.js'
//import adminOrderDetail from '3-section/section-admin-order-detail/_index.js'
//import notificationBell from 'utils/_notification_bell.js'
import runGallery from 'utils/_run_gallery.js'
import updateOrderListFrontend from 'utils/_update-order-list.js'
import {confirmBlockToggle} from 'utils/_confirm.js'

/*import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
import arraySupport from 'dayjs/plugin/arraySupport'
dayjs.extend(utc)
dayjs.extend(tz)
dayjs.extend(arraySupport)*/

import {changePriorityWindowToggle, changePriorityInit} from '4-component/change-priority/_index.js'

var currency = '€'

/**
 * @param {Event} event
 */
let onToggleHistoryStatusOrder = (event) => {
  event.preventDefault()
  const historyBlockElement = document.getElementById('order-status-history-block')
  if (!historyBlockElement) {
    return
  }
  historyBlockElement.classList.toggle('visible')
}

/**
 * @param {HTMLInputElement} priceElement
 * @param {HTMLSelectElement} designerElement
 * @param {HTMLInputElement} deadlineElement
 * @param {HTMLSelectElement} statusElement
 * @param {HTMLSelectElement} statusPaymentElement
 */
let getData = (
  priceElement,
  designerElement,
  deadlineElement,
  statusElement,
  statusPaymentElement,
) =>
  () => {

    //console.log('getData')
    //console.log(deadlineElement._flatpickr.latestSelectedDateObj)
    //console.log(Math.floor(deadlineElement._flatpickr.latestSelectedDateObj.getTime() / 1000))

    //return false
    // меняется представление даты в timestamp

    let statusPayment = '';
    if( statusPaymentElement ) {
      statusPayment = statusPaymentElement.value;
    }

    return {
      price: parseFloat(('' !== priceElement.value) ? priceElement.value : 0, 10),
      designer: designerElement.value,
      //deadline: Math.floor(deadlineElement._flatpickr.latestSelectedDateObj.getTime() / 1000),

      //deadline: Math.floor(deadlineElement._flatpickr.latestSelectedDateObj.getTime() / 1000),
      deadline: convertDateBeforeSend( deadlineElement._flatpickr.latestSelectedDateObj ),

      //deadline: '222',//1615291560
      status: statusElement.value,

      statusPayment: statusPayment,
    }
  }

/**
 * @param {HTMLInputElement} priceElement
 * @param {HTMLSelectElement} designerElement
 * @param {HTMLInputElement} deadlineElement
 * @param {HTMLSelectElement} statusElement
 * @param {HTMLSelectElement} statusPaymentElement
 */
let setData = (
  priceElement,
  designerElement,
  deadlineElement,
  statusElement,
  statusPaymentElement,
) =>
  (data) => {

    //console.log('flatpickr.setDate', data.deadline)
    //console.log('flatpickr.setDate', convertDateObject(parseInt(data.deadline, 10)))

    priceElement.value = (0 === data.price) ? '' : data.price.toString()
    designerElement.value = data.designer

    //deadlineElement._flatpickr.setDate( convertDateObject(parseInt(data.deadline, 10)) )

    //deadlineElement._flatpickr.setDate(new Date( parseInt(data.deadline, 10) * 1000))
    //deadlineElement._flatpickr.setDate( convertDateObject(parseInt(data.deadline, 10)) )
    statusElement.value = data.status

    if( statusPaymentElement ) {
      statusPaymentElement.value = data.statusPayment
    }

    //console.log('flatpickr.get', Math.floor(deadlineElement._flatpickr.latestSelectedDateObj.getTime() / 1000))
  }


let afterUpdateOrderList = (xhr, error) => {
  if( error ) {
    return false
  }

  let data = JSON.parse(xhr.responseText)

  updateOrderListFrontend(data)
}


let updateOrderList = () => {
  let searchParams = new URLSearchParams(window.location.search);
  if( searchParams.has('order_id') ) {
    searchParams.delete('order_id')
  }
  if( searchParams.has('user_id') ) {
    searchParams.delete('user_id')
  }

  const url = '/ru/admin/orders/list-ajax' + '?' + searchParams.toString()
  ajaxRequest(afterUpdateOrderList, url, {}, 'GET')
}


let afterUpdateOrder = (defaultData, dataSetter, isTransfer) =>
  /**
   * @param {XMLHttpRequest} xhr
   * @param {boolean} error
   */
  (xhr, error) => {
    if( error ) {
      loadingWindowHidden('process', '#page-ajax')
      loadingWindowVisible('error', '#page-ajax')
      return false
    }

    loadingWindowHidden('process', '#page-ajax')
    //loadingWindowVisible('success', '#page-ajax')

    updateOrderList()

    let newData = JSON.parse(xhr.responseText)

    if( newData['status'] === 'completed' && newData['isCalculate'] ) {
      document.querySelector('.order-detail-cards__order-details-change').classList.add('visible')
    }
    else {
      document.querySelector('.order-detail-cards__order-details-change').classList.remove('visible')
    }

    if( isTransfer ) {
      document.querySelector('.order-detail-cards__order-details-change').classList.remove('visible')

      document.querySelector('.section-admin-order-detail').dataset.isCalculate = 0

      let arrOptions = [];
      newData.availableStatuses.forEach(element => {
        arrOptions.push('<option value="'+element.key+'">'+element.value+'</option>');
      })

      document.getElementById("order_status_input").innerHTML = arrOptions.join();



      const priorityText = document.getElementById('order_detail_priority')
      if( priorityText ) {
        priorityText.innerText = newData['newPriority']
      }

      document.getElementById('order_deadline_input')._flatpickr.setDate( convertDateObject(parseInt(newData['deadline'], 10)) )

      let designerElement = document.getElementById('order_designer_input')
      if( designerElement ) {
        designerElement.value = ''
      }

      const materialText = document.getElementById('order_detail_material')
      if( materialText ) {
        materialText.innerText = newData['newMaterial']
      }

      const fileFormatText = document.getElementById('order_detail_file_format')
      if( fileFormatText ) {
        fileFormatText.innerText = newData['newFileFormat']
      }

      const commentText = document.querySelector('.order-detail-cards__comments-text')
      if( commentText ) {
        commentText.innerHTML = newData['newComment']
      }

      if( newData['orderComments'].length ) {
        let prevComments = `<div class="order-detail-cards__comments__prev">
            <div class="order-detail-cards__comments__prev-title">Предыдущий комментарий</div>`;
        newData['orderComments'].forEach((comment) => {
          prevComments += `<div class="order-detail-cards__comments__prev-dt">${ convertDateCE(parseInt(comment['date'], 10), false) }</div>
            <div class="order-detail-cards__comments-text">${ comment['text'] }</div>`;
        })
        prevComments += `</div>`;
        commentText.parentNode.insertBefore((new DOMParser).parseFromString(prevComments, document.contentType).body.childNodes[0], commentText.nextSibling);
      }

      /*const priorityElement = document.getElementById('order_change_priority_select')
      if( priorityElement ) {
        const priorityText = document.getElementById('order_detail_priority')
        if( priorityText ) {
          //priorityText.innerText = priorityElement.options[priorityElement.selectedIndex].text
        }
      }*/
    }

    Object.entries(defaultData).forEach(([key, value]) => {
      if( key === 'deadline' ) {
        //defaultData[key] = '111';
        //console.log('new deadline', newData[key])
        defaultData[key] = newData[key]
        if( newData['deadlineChange'] ) {
          //defaultData[key] = newData[key]
        }
        else {
          //defaultData[key] = convertDateObject(parseInt(newData[key], 10)).getTime() / 1000
          //defaultData[key] = convertDateObject(parseInt(newData[key], 10))
          //defaultData[key] = parseInt(newData[key], 10)
          //defaultData[key] = convertDateTimestamp( parseInt(newData[key], 10) )
          //console.log(key, defaultData[key])
          //defaultData[key] = newData[key]
        }
      }
      else if( key === 'price' ) {
        defaultData[key] = ''
      }
      else {
        defaultData[key] = newData[key]
      }
    })
    dataSetter(defaultData)

    if( newData.hasOwnProperty('complete_time') ) {
      if( newData['complete_time'] > 0 ) {
        //document.getElementById("order_needed_completed").innerHTML = dayjs(new Date(parseInt(newData['complete_time'], 10) * 1000)).format('YYYY-MM-DD HH:mm:ss');
        document.getElementById("order_needed_completed").innerHTML = convertDateCE(parseInt(newData['complete_time'], 10))
      }
      else {
        document.getElementById("order_needed_completed").innerHTML = 'нет'
      }
    }

    if( newData.hasOwnProperty('newStatus') && newData['newStatus'] ) {
      const historyTable = document.querySelector('.order-detail-cards__order-details-history-table tbody')
      var tr = document.createElement('tr');
      var td1 = document.createElement('td');
      var td2 = document.createElement('td');
      var td3 = document.createElement('td');
      var text1 = document.createTextNode(newData['newStatus']['user']);
      //var text2 = document.createTextNode( dayjs(new Date(parseInt(newData['newStatus']['date'], 10) * 1000)).format('YYYY-MM-DD HH:mm:ss') );
      var text2 = document.createTextNode( convertDateCE(parseInt(newData['newStatus']['date'], 10)) );
      var text3 = document.createTextNode(newData['newStatus']['status']);
      td1.appendChild(text1);
      td2.appendChild(text2);
      td3.appendChild(text3);
      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      historyTable.appendChild(tr);
    }

    //${ dayjs(new Date(parseInt(newData['newJob']['create'], 10) * 1000)).format('YYYY-MM-DD<br>HH:mm:ss') }
    //${ dayjs(new Date(parseInt(newData['newJob']['deadline'], 10) * 1000)).format('YYYY-MM-DD<br>HH:mm:ss') }

    if( newData.hasOwnProperty('newJob') && newData['newJob'] ) {
      const jobTable = document.querySelector('.order-detail-cards__sequencing-list')
      const jobItem = `<div class="order-detail-cards__sequencing-row" data-id="${ newData['newJob']['id'] }">
                    <div class="order-detail-cards__sequencing-col-1">
                        ${ convertDateCE(parseInt(newData['newJob']['create'], 10), true) }
                    </div>
                    <div class="order-detail-cards__sequencing-col-2">
                        ${ convertDateCE(parseInt(newData['newJob']['deadline'], 10), true) }
                    </div>
                    <div class="order-detail-cards__sequencing-col-3">
                        ${ newData['newJob']['price'] }${ currency }
                        <button data-id="${ newData['newJob']['id'] }" class="order-detail-cards__sequencing__delete">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path></svg>
                        </button>
                    </div>
                </div>`
      jobTable.prepend((new DOMParser).parseFromString(jobItem, document.contentType).body.childNodes[0])

      const newJobDeleteBtn = document.querySelector('.order-detail-cards__sequencing__delete[data-id="'+ newData['newJob']['id'] +'"]')
      if( newJobDeleteBtn ) {
        newJobDeleteBtn.addEventListener('click', jobDelete)
      }
    }


    if( newData.hasOwnProperty('jobDateCompleteUpdate') && newData['jobDateCompleteUpdate'] && newData['jobDateCompleteUpdate'].length ) {
      newData['jobDateCompleteUpdate'].forEach((job) => {
        document.querySelector('.order-detail-cards__sequencing-row[data-id="' + job['id'] + '"] .order-detail-cards__sequencing-col-2').innerHTML = convertDateCE(parseInt(job['deadline'], 10), true)
      })
    }


    if( newData.hasOwnProperty('price') ) {
      if( newData['price'] != 0 ) {
        document.getElementById('order-detail-cards-price').innerHTML = newData['price'] + ' '+currency
      }
    }

    document.getElementById('order_price_input').value = ''

    document.getElementById('order_complete_window').classList.remove('visible')

    if( newData.hasOwnProperty('jobsPaidIds') && newData['jobsPaidIds'].length ) {
      newData['jobsPaidIds'].forEach((jobId)=>{
        const jobItem = document.querySelector('.order-detail-cards__sequencing-row[data-id="'+jobId+'"]')
        if( jobItem ) {
          jobItem.classList.add('--is-paid')
        }
      })
    }
  }

let getFormData = (defaultData, currentData) => {
  let formData = new FormData
  //console.log('getFormData')
  //console.log('defaultData:')
  //console.log(defaultData)
  Object.entries(defaultData).forEach(([key, value]) => {

    if( key == 'deadline' ) {
      //console.log('defaultData[key]', defaultData[key])
      //console.log('currentData[key]', currentData[key])

      if (defaultData[key] !== currentData[key]) {
        formData.append(key, currentData[key] )
        //formData.append(key, convertDateBeforeSend( currentData[key] ))
      }
    }
    else {
      if (defaultData[key] !== currentData[key]) {
        //if( key != 'deadline' ) {
        formData.append(key, currentData[key])
      }
    }



  })

  return formData.entries().next().done ? null : formData
}


let completeObject = {}

let completeOrderWindowVisible = (callback, url, formData) => {
  completeObject = {
    callback:callback, url:url, formData:formData
  }

  const fileListElement = document.querySelector('.content-admin-order-detail__complete-file-list')
  fileListElement.innerHTML = ''

  let files = document.querySelectorAll('.--result-files .dropzone-previews .order-detail-cards__attachments-item2-wrap')

  files.forEach(
    function(currentValue, currentIndex, listObj) {
      let thumbnail = '';
      if( currentValue.querySelector('.data-dz-thumbnail').getAttribute('src') ) {
        thumbnail = `<img class="content-admin-order-detail__thumbnail" alt="${ currentValue.querySelector('.data-dz-thumbnail').getAttribute('alt') }" src="${ currentValue.querySelector('.data-dz-thumbnail').getAttribute('src') }">`
      }
      else {
        thumbnail = `<div class="content-admin-order-detail__attachments-extension">${ currentValue.querySelector('.dz-file-extension').innerHTML }</div>`
      }

      let fileItem = `<label class="content-admin-order-detail__attachments-item">
                        <div class="content-admin-order-detail__attachments-item-preview">
                            <div class="content-admin-order-detail__attachments-checkbox">
                                <label>
                                    <input type="checkbox" name="file_id[]" value="${ currentValue.querySelector('.dz-file-checkbox').value }" class="content-admin-order-detail__file-checkbox">
                                    <span class="content-admin-order-detail__attachments-checkbox-indicator"></span>
                                </label>
                            </div>
                            ${ thumbnail }
                        </div>
                        <div class="content-admin-order-detail__attachments-item-fileinfo">
                            <div class="content-admin-order-detail__attachments-item-ext">Формат: <span class="content-admin-order-detail__extension">${ currentValue.querySelector('.dz-file-extension').innerHTML }</span></div>
                            <div class="content-admin-order-detail__attachments-item-filename">${ currentValue.querySelector('.dz-filename span').innerHTML }</div>
                            <div class="content-admin-order-detail__attachments-item-date">${ currentValue.querySelector('.dz-created').innerHTML }</div>
                        </div>
                    </label>`
      fileListElement.prepend((new DOMParser).parseFromString(fileItem, document.contentType).body.childNodes[0])
    }
  )

  document.getElementById('order_complete_window').classList.add('visible')
}

/**
 * @param {Function} callback
 * @param {int|string} orderId
 * @param {object} defaultData
 * @param {Function} dataGetter
 * @param {string} type
 * @param {string} sectionSelector
 */
let updateOrder = (callback, orderId, defaultData, dataGetter, type, sectionSelector) =>
  () => {
    let url = '/{!_locale}/admin/orders/{!id}/update'
      .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
      .replaceAll('{!id}', orderId)

    //console.log('new data', dataGetter())

    let formData = getFormData(defaultData, dataGetter())

    if( type === 'save-plus' ) {
      if( !formData ) {
        formData = new FormData
      }
      formData.append('type', type)
    }

    // если это кнопка Сохранить, то проверить, что новый статус это Завершен
    // если это кнопка Сохранить плюс, то проверить, что следующий статус завершен
    // если да, то не отправлять форму и показать окно с выбором действий
    const isCalculate = document.querySelector(sectionSelector).dataset.isCalculate

    let status = ''
    if( formData ) {
      status = formData.get('status')
    }

    if( isCalculate == 0 ) {
      if( type === 'save-plus' ) {
        if( status === 'completed' || (!status && document.getElementById('order_status_input').value == 'in_work') ) {
          completeOrderWindowVisible(callback, url, formData)
          return false;
        }
      }
      else {
        if( status === 'completed' ) {
          completeOrderWindowVisible(callback, url, formData)
          return false;
        }
      }
    }

    if (formData) {
      loadingWindowVisible('process', '#page-ajax')
      ajaxRequest(callback, url, formData, 'POST')
    } else {
      console.warn('Data not changed!')
    }
  }


/**
 * @param {Function} callback
 * @param {int|string} orderId
 */
let transferToOrder = (callback, orderId) =>
  () => {
    let url = '/{!_locale}/admin/orders/{!id}/transfer-to-order'
      .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
      .replaceAll('{!id}', orderId)
    let formData = new FormData

    const priorityElement = document.getElementById('order_change_priority_select')
    if( priorityElement ) {
      formData.append('priority', priorityElement.value);
    }

    const materialElement = document.getElementById('order_new_form_material')
    if( materialElement ) {
      formData.append('material', materialElement.value);
    }

    const fileFormatElement = document.getElementById('order_new_form_file_format')
    if( fileFormatElement ) {
      formData.append('file_format', fileFormatElement.value);
    }

    const commentElement = document.getElementById('order_new_form_comment')
    if( commentElement ) {
      formData.append('comment', commentElement.value);
    }

    changePriorityWindowToggle('hide')

    loadingWindowVisible('process', '#page-ajax')
    ajaxRequest(callback, url, formData, 'POST')
  }



let completedOrder = (event) => {
  event.preventDefault()
  //console.log(completeObject)

  let formData = completeObject.formData
  let url = completeObject.url
  let callback = completeObject.callback

  const formElement = document.getElementById('order_complete_form');
  if (formElement) {
    let addFormData = new FormData(formElement)
    addFormData = addFormData.entries().next().done ? null : addFormData

    if( addFormData ) {
      if( !formData ) {
        formData = new FormData()
      }
      for (var pair of addFormData.entries()) {
        formData.append(pair[0], pair[1]);
      }
    }
  }

  if (formData) {
    loadingWindowVisible('process', '#page-ajax')
    ajaxRequest(callback, url, formData, 'POST')
  } else {
    console.warn('Data not changed!')
  }
}


let jobDelete = (event) => {
  event.preventDefault()
  //console.log('jobDelete')
  jobDeleteId = event.currentTarget.getAttribute('data-id')
  //console.log('job id: ', jobDeleteId)
  confirmBlockToggle('show')
}

let jobDeleteId = 0


/**
 * @param {string} historyLinkId
 * @param {string} historyCloseId
 */
export default (historyLinkId, historyCloseId) => () => {
  const sectionSelector = '.section-admin-order-detail';
  let orderId = document.querySelector(sectionSelector).dataset.orderId
  let priceElement = document.getElementById('order_price_input')
  let designerElement = document.getElementById('order_designer_input')
  let deadlineElement = document.getElementById('order_deadline_input')
  let statusElement = document.getElementById('order_status_input')
  let statusPaymentElement = document.getElementById('status_payment_input')

  let language = document.querySelector(sectionSelector).dataset.orderLang

  currency = '€'
  if( language == 'ru' ) {
    currency = '₽'
  }


  additionalDescription(orderId)

  if( deadlineElement ) {

    //console.log(convertDateObject(parseInt(deadlineElement.dataset.unixTimestamp, 10)))

    flatpickr && flatpickr(document.getElementById('order_deadline_input'), {
      //defaultDate: (new Date( parseInt(deadlineElement.dataset.unixTimestamp, 10) * 1000)),
      defaultDate: convertDateObject(parseInt(deadlineElement.dataset.unixTimestamp, 10)),
      enableTime: true,
      enableSeconds: false,
      time_24hr: true,
      minuteIncrement: 1,
      dateFormat: 'Y-m-d H:i',
      "locale": "ru",

      /*parseDate(dateString, format) {

        var a = dayjs(dateString)
        let dateTz = a.utc().tz("Europe/Vienna")

        //console.log('flatpickr parseDate')
        //console.log(dateTz)

        return new Date(
          dateTz.year(),
          dateTz.month(),
          dateTz.date(),
          dateTz.hour(),
          dateTz.minute(),
          dateTz.second()
        );
      },

      formatDate(date, format) {
        format = 'YYYY-MM-DD HH:mm'
        console.log('flatpickr formatDate')
        console.log(date, format)

        var a = dayjs([
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds()
        ])

        let dateTz = a.utc().tz("Europe/Vienna")

        console.log(dateTz.format(format))

        return dateTz.format(format)
      },*/
    });

    //console.log('flatpickr getData')
    //console.log(deadlineElement._flatpickr.latestSelectedDateObj)
    //console.log(Math.floor(deadlineElement._flatpickr.latestSelectedDateObj.getTime() / 1000))

  }


  //convertDateBeforeSend(1615377960)

  //convertDateTimestamp2()


  if( priceElement ) {
    let dataGetter = getData(priceElement, designerElement, deadlineElement, statusElement, statusPaymentElement)
    let dataSetter = setData(priceElement, designerElement, deadlineElement, statusElement, statusPaymentElement)

    let defaultData = dataGetter()
    //console.log('defaultData', defaultData)

    document.querySelector('.order-detail-cards__price-btn-save').addEventListener('click', updateOrder(afterUpdateOrder(defaultData, dataSetter, false), orderId, defaultData, dataGetter, 'save', sectionSelector))
    document.querySelector('.order-detail-cards__price-btn-save-plus').addEventListener('click', updateOrder(afterUpdateOrder(defaultData, dataSetter, false), orderId, defaultData, dataGetter, 'save-plus', sectionSelector))

    const transferOrderBtn = document.querySelector('.order-detail-cards__order-details-change-btn')
    if( transferOrderBtn ) {
      //document.querySelector('.order-detail-cards__order-details-change-btn').addEventListener('click', transferToOrder(afterUpdateOrder(defaultData, dataSetter, true), orderId, defaultData, dataGetter, 'transfer-to-order'))

      transferOrderBtn.addEventListener('click', ()=>{
        changePriorityWindowToggle('show')
      })

      const changePriorityBtnYes = document.getElementById('change-priority-admin-button-yes')
      if( changePriorityBtnYes ) {
        changePriorityBtnYes.addEventListener('click', transferToOrder(afterUpdateOrder(defaultData, dataSetter, true), orderId, defaultData, dataGetter, 'transfer-to-order'))
      }

      changePriorityInit()
    }

    if( document.querySelector('.content-admin-order-detail__complete-button') ) {
      document.querySelector('.content-admin-order-detail__complete-button').addEventListener('click', completedOrder)
    }
  }


  //console.log(orderId)

  if( window.innerWidth < 1200 && window.innerWidth >= 576 ) {
    document.getElementById('order-detail-card-order-tablet').appendChild( document.getElementById('order-detail-cards-order-details') );
  }

  loadingWindowHandler('#page-ajax')

  //document.getElementsByTagName('textarea').forEach((e) => {textareaCounter(e)})

  document.querySelector(historyLinkId).addEventListener('click', onToggleHistoryStatusOrder)
  document.querySelector(historyCloseId).addEventListener('click', onToggleHistoryStatusOrder)


  orderFiles(
    orderId,
    'order_attachments',
    'order_attachments_input',
    '--attachments',
  )
  const resultFilesDropzone = orderFiles(
    orderId,
    'order_result_files',
    'order_result_files_input',
    '--result-files',
  )
  const projectFilesDropzone = orderFiles(
    orderId,
    'order_project_files',
    'order_project_files_input',
    '--project-files',
  )
  chat(
    orderId,
    false,
    '/account/messages/add',
  )
  chat(
    orderId,
    true,
    '/admin/messages/add',
  )


  document.querySelector('.upload-type__button').addEventListener('click', (event) => {
    event.preventDefault()
    const uploadTypeForm = document.querySelector('.upload-type')
    if( uploadTypeForm ) {
      uploadTypeForm.classList.remove('visible')
    }

    let pxfVisibility = '';
    const radioButtons = document.querySelectorAll('.upload-type .form-check-input[name="pxf_visibility"]')
    radioButtons.forEach((element) => {
      if( element.checked ) {
        pxfVisibility = element.value
      }
    })

    resultFilesDropzone.pxfVisibility = pxfVisibility
    resultFilesDropzone.processQueue()
  })



  let urlDownloadAll = window.location.protocol + "//" + window.location.host + "" + '/{!_locale}/admin/orders/{!id}/download-all/'
    .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
    .replaceAll('{!id}', orderId)

  let urlDownloadSelected = window.location.protocol + "//" + window.location.host + "" + '/{!_locale}/admin/orders/{!id}/download-selected/'
    .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
    .replaceAll('{!id}', orderId)

  const containerProjectFiles = document.querySelector('.--project-files');
  /*containerProjectFiles.querySelector('.order-detail-cards__attachments-all-link').addEventListener('click', () => {
    if( containerProjectFiles.querySelectorAll('.dz-image-preview').length ) {
      //window.location.href = urlDownloadAll + 'project';
      openDownloadLink(urlDownloadAll, 'project')
    }
  })*/

  containerProjectFiles.querySelector('.order-detail-cards__attachments-all-icon').addEventListener('click', (event) => {
    event.preventDefault()
    downloadSelected(containerProjectFiles, urlDownloadSelected, 'project')
  })

  const projectFilesDeleteButton = containerProjectFiles.querySelector('.order-detail-cards__attachments-all-delete')
  if( projectFilesDeleteButton ) {
    projectFilesDeleteButton.addEventListener('click', (event) => {
      event.preventDefault()
      deleteSelected(containerProjectFiles)
    })
  }


  const containerResultFiles = document.querySelector('.--result-files');
  /*containerResultFiles.querySelector('.order-detail-cards__attachments-all-link').addEventListener('click', () => {
    if( containerResultFiles.querySelectorAll('.dz-image-preview').length ) {
      openDownloadLink(urlDownloadAll, 'result')
    }
  })*/

  containerResultFiles.querySelector('.order-detail-cards__attachments-all-icon').addEventListener('click', (event) => {
    event.preventDefault()
    downloadSelected(containerResultFiles, urlDownloadSelected, 'result')
  })

  const resultFilesDeleteButton = containerResultFiles.querySelector('.order-detail-cards__attachments-all-delete')
  if( resultFilesDeleteButton ) {
    resultFilesDeleteButton.addEventListener('click', (event) => {
      event.preventDefault()
      deleteSelected(containerResultFiles)
    })
  }


  const containerAttachmentsFiles = document.querySelector('.--attachments');
  /*containerAttachmentsFiles.querySelector('.order-detail-cards__attachments-all-link').addEventListener('click', () => {
    if( containerAttachmentsFiles.querySelectorAll('.dz-image-preview').length ) {
      openDownloadLink(urlDownloadAll, 'attachments')
    }
  })*/

  containerAttachmentsFiles.querySelector('.order-detail-cards__attachments-all-icon').addEventListener('click', (event) => {
    event.preventDefault()
    downloadSelected(containerAttachmentsFiles, urlDownloadSelected, 'attachments')
  })

  const attachmentsFilesDeleteButton = containerAttachmentsFiles.querySelector('.order-detail-cards__attachments-all-delete')
  if( attachmentsFilesDeleteButton ) {
    attachmentsFilesDeleteButton.addEventListener('click', (event) => {
      event.preventDefault()
      deleteSelected(containerAttachmentsFiles)
    })
  }


  const jobDeleteButtonList = document.querySelectorAll('.order-detail-cards__sequencing__delete')
  if( jobDeleteButtonList.length ) {
    jobDeleteButtonList.forEach((element) => {
      element.addEventListener('click', jobDelete)
    })
  }

  const confirmYes = document.querySelector('.confirm__block .job-confirm-button-yes')
  if( confirmYes ) {
    confirmYes.addEventListener('click', (event) => {
      event.preventDefault()
      confirmBlockToggle('hide')

      loadingWindowVisible('process', '#page-ajax')

      document.querySelector('.loading__error-text').innerHTML = ''

      let openUrl = '/{!_locale}/admin/orders/{!id}/job-delete'

      //const url = '/ru/admin/orders/job-delete' + '?id=' + id
      //ajaxRequest(afterJobDelete, url, {}, 'GET')


      ajaxRequest(
        (xhr, error) => {
          loadingWindowHidden('process', '#page-ajax')

          if( error ) {
            loadingWindowVisible('error', '#page-ajax')
          }

          const data = JSON.parse(xhr.response)

          if( data['status'] == 'success' ) {
            document.querySelector('.order-detail-cards__sequencing-row[data-id="' + jobDeleteId + '"]').remove()

            if( data['price'] != '0,0' ) {
              document.getElementById('order-detail-cards-price').innerHTML = data['price'] + ' '+currency
              document.querySelector('.order-list-admin__body-item[data-id="' + orderId + '"] .order-list-admin__value-price').innerHTML = data['price']
            }
            else {
              document.getElementById('order-detail-cards-price').innerHTML = '- '+currency
              document.querySelector('.order-list-admin__body-item[data-id="' + orderId + '"] .order-list-admin__value-price').innerHTML = 0
            }
          }
          else {
            loadingWindowVisible('error', '#page-ajax')
          }

        },
        (openUrl+'?ajax=1')
          .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
          .replaceAll('{!id}', jobDeleteId)
      )

    })
  }


  const confirmNo = document.querySelector('.confirm__block .job-confirm-button-no')
  if( confirmNo ) {
    confirmNo.addEventListener('click', (event) => {
      event.preventDefault()
      confirmBlockToggle('hide')
    })
  }



  if( window.innerWidth < 768 ) {
    const cardTitles = document.querySelectorAll('.section-admin-order-detail__card-title')
    if( cardTitles.length ) {
      cardTitles.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault()
          event.target.nextElementSibling.classList.toggle('hidden')
          event.target.classList.toggle('active')
        })
      })
    }

    const chatCardTitle = document.querySelector('.order-detail-cards__chat-body.--readonly .order-detail-cards__chat-title')
    if( chatCardTitle ) {
      chatCardTitle.addEventListener('click', (event) => {
        event.preventDefault()
        event.target.nextElementSibling.classList.toggle('hidden')
        event.target.classList.toggle('active')
      })
    }
  }


  const saveNoteButton = document.querySelector('.header-ajax__admin-note-btn')

  if( saveNoteButton ) {
    saveNoteButton.addEventListener('click', (event)=>{
      event.preventDefault();

      let openUrl = '/{!_locale}/admin/orders/{!id}/discount-description'
      openUrl = openUrl.replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
        .replaceAll('{!id}', orderId)

      const textarea = document.getElementById('header-ajax__admin-note-textarea')

      let formData = new FormData()
      formData.append('discountDescription', textarea.value);
      formData.append('orderId', orderId);

      ajaxRequest(
        (xhr, error) => {
          //console.log('ajax callback', xhr)
        },
        (openUrl+'?ajax=1'),
        formData,
        'POST'
      )
    })
  }


  const bubble = document.querySelector('.order-notification__item[data-order="'+orderId+'"]')
  if( bubble ) {
    bubble.remove()
  }

  const themeAdmin = document.querySelector('.order-list-admin__body-item[data-id="'+orderId+'"] .order-list-admin__value-notification')
  if( themeAdmin ) {
    themeAdmin.classList.remove('order-list-admin__value-notification--alert')
  }

  convertDateAuto()

  runGallery()

}
